import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { isArray } from 'lodash-es';
import {
  AppConfigService,
  BackendService,
  FileCreateRequest,
  FileCreateResponse,
} from '@ipg/ngx-frontend-toolset';

@Injectable({
  providedIn: 'root',
})
export class FileUploadService {
  private readonly _backend = inject(BackendService);
  private readonly _config = inject(AppConfigService);
  private readonly _http = inject(HttpClient);

  /**
   * Upload files to the backend.
   *
   * This has the same implementation as FileService.create.
   * The only difference is that the `upload` method returns progress events,
   * which FileService.create does not.
   *
   * @param data The {@link FileCreateRequest data} to provide.
   * @returns Observable<HttpEvent<T>>
   */
  upload<T extends FileCreateResponse>(data: FileCreateRequest) {
    const { filePathName, defaultPublicValue } = this._config.config.fileConfig;
    const url = this._backend.buildUrl(filePathName);

    const formData = new FormData();

    formData.append('file', data.file, data.file.name);

    const references = isArray(data.references) ? data.references : [data.references];

    formData.append('references', JSON.stringify(references));
    formData.append('public', `${data.public ?? defaultPublicValue}`);
    formData.append('fileId', data.fileId ?? '');

    if (data.metadata) {
      formData.append('metadata', JSON.stringify(data.metadata));
    }

    return this._http.post<T>(url, formData, {
      observe: 'events',
      reportProgress: true,
    });
  }
}
